export const formatDate = (date) => {
    const d = new Date(date)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

//activation date formatter
export const dateFormatter = (cell) => {
    if (cell === null || cell === undefined) return '-'
    if (cell !== '-') {
        const date = new Date(cell)
        const day = String(date.getDate()).padStart(2, '0')
        const month = date.toLocaleString('default', { month: 'long' }) // Months are zero-indexed
        const year = date.getFullYear()
        return `${day} ${month} ${year}`
    }
    return '-'
}

// Format date to DD/MM/YYYY
export const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
}
